import { TutorialStep } from "..";

export const DatasetModalSteps: TutorialStep[] = [
  {
    target: "#dataset-modal",
    content: "여기서 원하는 이미지들을 모아 데이터셋을 생성할 수 있습니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#server-image-list",
    content: "서버에 존재하는 이미지들을 선택합니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#temp-image-list",
    content: "선택한 이미지 리스트는 여기서 확인됩니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#upload-button",
    content: "필요한 이미지를 업로드하여 사용할 수도 있습니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "top",
    disableOverlayClose: true,
  },
  {
    target: "#select-image-file",
    content: `폴더는 더블클릭하여 진입합니다.\n
          클릭: 단일 선택, \n ctrl+클릭: 복수 선택\n
          폴더를 두 단계 진입한 뒤 폴더나 파일을 선택해보세요.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    nextTrigger: "select-image-file",
    disableOverlayClose: true,
  },
  {
    target: "#open-label-modal",
    content: `폴더/파일을 선택한 후 라벨링을 하여 리스트에 넣어줍니다.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#select-label",
    content: "선택한 파일을 특정 라벨로 선택하여 넣어줍니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    nextTrigger: "select-label",
    disableOverlayClose: true,
  },
  {
    target: "#remove-temp-image-list",
    content: `파일을 선택하여 리스트에서 제거할 수도 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#confirm-create-dataset",
    content: `확인을 눌러주세요.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#selected-file-info",
    content: `선택한 파일들을 확인할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#next-btn",
    content: "버튼을 클릭하여 다음 단계를 진행합니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
